export const menuBurguer = [
  '0 0 32 32',
  `
    <path stroke-linejoin="miter" stroke-linecap="round" stroke-miterlimit="10" stroke-width="2.4" stroke="#fff" fill="#fff" d="M1.375 5.364h29.25M1.375 16h29.25M1.375 26.636h29.25"></path>

`,
]
